const firebaseConfig = {
    apiKey: process.env.REACT_APP_NOT_SECRET_CODE_apiKey,
    authDomain: process.env.REACT_APP_NOT_SECRET_CODE_authDomain,
    projectId: process.env.REACT_APP_NOT_SECRET_CODE_projectId,
    storageBucket: process.env.REACT_APP_NOT_SECRET_CODE_storageBucket,
    messagingSenderId: process.env.REACT_APP_NOT_SECRET_CODE_messagingSenderId,
    appId: process.env.REACT_APP_NOT_SECRET_CODE_appId,
    measurementId: process.env.REACT_APP_NOT_SECRET_CODE_measurementId
  };

  export default firebaseConfig;

  